export default __webpack_public_path__ + "static/media/male_login.d9423051.png";